export default {
  agents: 'Агенты',
  manageAgentsTitle: 'Управление агентами',
  manageAgentsDescription: 'Создавайте собственных агентов для ваших задач.',
  agentTemplatesTitle: 'Шаблоны агентов',
  agentTemplatesDescription:
    'Возьмите готовую основу и настройте любые поля под свой рабочий процесс.',
  agentTemplatesLoading: 'Загрузка шаблонов агентов',
  agentTemplatesLoadFailed: 'Не удалось загрузить шаблоны агентов.',
  noAgentTemplates: 'Шаблоны агентов пока недоступны.',
  agentTemplateFallbackDescription: 'Готовый шаблон агента.',
  agentTemplateLoading: 'Загрузка шаблона агента',
  agentTemplateLoadFailed: 'Не удалось загрузить этот шаблон агента.',
  useTemplate: 'Использовать шаблон',
  agentTemplateCategoryFilter: 'Фильтр шаблонов агентов по категории',
  agentTemplateCategoryAll: 'Все',
  agentTemplateCategoryManagement: 'Управление',
  agentTemplateCategoryDevelopment: 'Разработка',
  agentTemplateCategoryMarketing: 'Маркетинг',
  agentTemplateCategorySales: 'Продажи',
  agentTemplateCategoryHr: 'HR',
  agentTemplateCategorySupport: 'Поддержка',
  agentTemplateCategoryOther: 'Другое',
  documentationAgentName: 'Агент документации',
  documentationAgentDescription:
    'Анализирует завершённые задачи и готовит обоснованные обновления документации.',
  sprintPlannerName: 'Планировщик спринта',
  sprintPlannerDescription:
    'Формирует план спринта по его цели, capacity и текущему бэклогу.',
  taskAnalystName: 'Аналитик задач',
  taskAnalystDescription:
    'Описывает и оценивает задачи с учётом стратегии, роадмапа и кода.',
  salesCoordinatorName: 'Координатор продаж',
  salesCoordinatorDescription:
    'Готовит персонализированные письма заказчикам по стратегии и данным компании и отправляет их после подтверждения.',
  newAgent: 'Новый агент',
  editAgent: 'Редактировать агента',
  createAgent: 'Создать агента',
  saveAgentChanges: 'Сохранить изменения',
  manageAgents: 'Управление',
  searchAgents: 'Поиск агентов',
  noDescription: 'Без описания',
  toolsCount_one: '{{count}} инструмент',
  toolsCount_few: '{{count}} инструмента',
  toolsCount_many: '{{count}} инструментов',
  edit: 'Редактировать',
  deleteAgent: 'Удалить агента',
  deleteAgentTitle: 'Удалить агента?',
  deleteAgentDescription:
    'Агент «{{name}}» будет удалён без возможности восстановления.',
  cancel: 'Отмена',
  retry: 'Повторить',
  toolsLoadFailed: 'Не удалось загрузить каталог tools.',
  agentsLoadFailed: 'Не удалось загрузить агентов организации.',
  agentLoadFailed: 'Не удалось загрузить агента.',
  agentNotFound: 'Агент не найден или был удалён.',
  noAgents: 'В организации пока нет кастомных агентов.',
  noAgentsMatching: 'По вашему запросу агенты не найдены.',
  name: 'Название',
  namePlaceholder: 'QA reviewer',
  description: 'Описание',
  descriptionPlaceholder: 'Проверяет задачи, PR и release notes',
  instructions: 'Инструкции',
  instructionsDescription: 'Опишите цель агента и правила его поведения.',
  instructionsPlaceholder:
    'Ты — ассистент по релизам. Проверяй готовность задач в Jira, находи связанные документы и кратко сообщай о рисках. Не изменяй данные без подтверждения пользователя.',
  refineInstructions: 'Улучшить инструкцию',
  instructionRefinementFailed:
    'Не удалось улучшить инструкцию. Попробуйте ещё раз.',
  tools: 'Инструменты',
  capabilities: 'Возможности',
  toolsDescription: 'Выберите инструменты, которые сможет использовать агент.',
  triggers: 'Триггеры',
  triggersDescription: 'Запускайте агента по расписанию или событию.',
  addTrigger: 'Добавить триггер',
  triggerDraft: 'Будет создан вместе с агентом',
  deleteTriggerTitle: 'Удалить триггер?',
  deleteTriggerDescription: 'Триггер «{{name}}» будет удалён.',
  triggerCreatePartialFailed:
    'Агент создан, но часть триггеров не сохранилась.',
  defaultCapabilities: 'Базовые возможности',
  workspaceIntegrations: 'Интеграции воркспейса',
  docs: 'Документы',
  jira: 'Jira',
  confluence: 'Confluence',
  github: 'GitHub',
  gmail: 'Gmail',
  yandexMail: 'Яндекс Почта',
  calendar: 'Календарь',
  requiresProvider: 'Требуется {{provider}}',
  noConnectionRequired: 'Подключение не требуется',
  selectAll: 'Выбрать все',
  clearAll: 'Снять все',
  toggleCategoryTools: 'Переключить инструменты категории {{category}}',
  selectedToolsCount: 'Выбрано {{selected}} из {{total}}',
  noToolsRegistered: 'Инструменты пока не зарегистрированы.',
  nameRequired: 'Введите название агента.',
  nameInvalid:
    'Название должно содержать от 2 до 60 букв, цифр, пробелов или дефисов.',
  nameAlreadyExists: 'Агент с таким названием уже существует',
  instructionsRequired: 'Добавьте инструкции для агента.',
  settings: 'Настройки',
  settingsDescription: 'Настройте название, описание и внешний вид агента.',
  generateName: 'Сгенерировать название',
  generateDescription: 'Сгенерировать описание',
  metadataGenerationFailed: 'Не удалось сгенерировать значение. Повторите.',
  chooseAgentIcon: 'Выбрать иконку агента',
  selectAgentIcon: 'Выбрать иконку {{icon}}',
  tags: 'Теги',
  addTag: 'Добавить тег',
  tagInput: 'Новый тег',
  tagPlaceholder: 'Например, Релизы',
  removeTag: 'Удалить тег {{tag}}',
  agentCreated: 'Агент создан',
  agentUpdated: 'Агент обновлен',
  agentDeleted: 'Агент удален',
  agentCreateFailed: 'Не удалось создать агента',
  agentUpdateFailed: 'Не удалось обновить агента',
  agentDeleteFailed: 'Не удалось удалить агента',
  laplaceDefault: 'Laplace',
  selectAgent: 'Выбрать агента',
  agentSelectorMentionConflict:
    'Выбранный агент не совпадает с @handle в начале сообщения.',
  agentUnavailable: 'Выбранный агент больше недоступен.',
  allAgents: 'Все',
  createdByMe: 'Созданы мной',
  sortAgents: 'Сортировка',
  recentlyUpdated: 'Недавно обновленные',
  sortByName: 'По имени',
  agent: 'Агент',
  owner: 'Владелец',
  updated: 'Обновлен',
  actions: 'Действия',
  agentActions: 'Действия агента {{name}}',
  you: 'Вы',
}
